let webGl2Supported: boolean | undefined;

/**
 * Whether this browser can create a WebGL2 context.
 *
 * maplibre-gl v6 renders with WebGL2 only and throws `GPUInitializationError` from the
 * `Map` constructor when the context cannot be created (headless crawlers, blocklisted
 * GPUs, WebGL disabled). Callers check this first so they can degrade instead of throwing
 * halfway through a page initializer. The probe runs once; its context is released again.
 */
export const supportsWebGl2 = (): boolean => {
  if (webGl2Supported === undefined) {
    try {
      const context = document.createElement("canvas").getContext("webgl2");
      webGl2Supported = context !== null;
      context?.getExtension("WEBGL_lose_context")?.loseContext();
    } catch {
      webGl2Supported = false;
    }
  }

  return webGl2Supported;
};
